(() => {
  if (customElements.get('tcd-virax-promotion')) return;
  class ViraxPromotion extends HTMLElement {
    connectedCallback() {
      this.config = JSON.parse(this.querySelector('[data-config]').textContent);
      this.ids = new Set(this.config.qualifyingIds.map(Number));
      this.giftId = Number(this.dataset.giftId);
      this.status = this.querySelector('[data-status]');
      this.claim = this.querySelector('[data-claim]');
      this.panel = this.querySelector('[data-panel]');
      this.tab = this.querySelector('[data-reopen]');
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      let dismissed = false;
      try { dismissed = sessionStorage.getItem('tcd-virax-promo-dismissed') === '1'; } catch (_) {}
      this.panel.hidden = dismissed;
      this.tab.hidden = !dismissed;
      this.querySelector('[data-close]').addEventListener('click', () => {
        this.panel.hidden = true; this.tab.hidden = false; this.tab.focus();
        try { sessionStorage.setItem('tcd-virax-promo-dismissed', '1'); } catch (_) {}
      }, options);
      this.tab.addEventListener('click', () => {
        this.panel.hidden = false; this.tab.hidden = true;
        this.querySelector('[data-close]').focus();
        try { sessionStorage.removeItem('tcd-virax-promo-dismissed'); } catch (_) {}
        this.refresh();
      }, options);
      this.claim.addEventListener('click', () => this.addGift(), options);
      this.updateHandler = () => this.refresh();
      ['on:cart:add', 'on:line-item:change', 'on:cart:change', 'cart:updated', 'tcd:cart:updated'].forEach(name => document.addEventListener(name, this.updateHandler, options));
      window.addEventListener('pageshow', this.updateHandler, options);
      window.addEventListener('focus', this.updateHandler, options);
      this.refresh();
    }
    disconnectedCallback() { this.controller?.abort(); }
    async cart() {
      const response = await fetch(`${this.dataset.root}cart.js`, { cache: 'no-store', credentials: 'same-origin' });
      if (!response.ok) throw new Error('Cart unavailable');
      return response.json();
    }
    state(cart) {
      const gift = cart.items.filter(item => Number(item.variant_id) === this.giftId);
      const spend = cart.items.reduce((sum, item) => sum + (this.ids.has(Number(item.product_id)) && Number(item.variant_id) !== this.giftId ? item.final_line_price : 0), 0);
      return { gift, spend, qualifies: cart.currency === 'GBP' && spend >= 20000 };
    }
    render(cart) {
      const state = this.state(cart);
      this.hidden = !(this.dataset.popup === 'true' || state.spend > 0 || state.gift.length);
      this.claim.hidden = true;
      if (cart.currency !== 'GBP') { this.hidden = true; return; }
      if (state.gift.length) {
        this.status.textContent = state.gift.every(item => item.final_line_price === 0) ? this.config.messages.added : this.config.messages.paid_warning;
      } else if (state.qualifies) {
        const available = this.dataset.giftAvailable === 'true';
        this.status.textContent = available ? this.config.messages.qualified : this.config.messages.unavailable;
        this.claim.hidden = !available;
      } else {
        const amount = new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' }).format((20000 - state.spend) / 100);
        this.status.textContent = this.config.messages.remaining.replace('[amount]', amount);
      }
    }
    async refresh() {
      if (this.busy) return;
      const revision = this.revision = (this.revision || 0) + 1;
      try { const cart = await this.cart(); if (revision === this.revision && !this.busy && this.isConnected) this.render(cart); }
      catch (_) { this.claim.hidden = true; }
    }
    async addGift() {
      if (this.busy) return;
      this.busy = true; this.revision = (this.revision || 0) + 1;
      this.claim.disabled = true;
      this.status.textContent = this.config.messages.loading;
      try {
        const before = await this.cart(); const state = this.state(before);
        if (!state.qualifies || state.gift.length || this.dataset.giftAvailable !== 'true') { this.render(before); return; }
        const response = await fetch(`${this.dataset.root}cart/add.js`, {
          method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: this.giftId, quantity: 1, properties: { '_tcd_virax_promo': '382655' } }] })
        });
        if (!response.ok) throw new Error('Bag could not be added');
        const after = await this.cart();
        const added = after.items.find(item => Number(item.variant_id) === this.giftId && item.properties?._tcd_virax_promo === '382655');
        if (!added || added.final_line_price !== 0) {
          if (added) {
            const remove = await fetch(`${this.dataset.root}cart/change.js`, {
              method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: added.key, quantity: 0 })
            });
            if (!remove.ok) { window.location.assign(this.dataset.cartUrl); return; }
          }
          throw new Error('Free discount unavailable');
        }
        window.location.assign(this.dataset.cartUrl);
      } catch (_) { this.status.textContent = this.config.messages.error; }
      finally { this.busy = false; this.claim.disabled = false; }
    }
  }
  customElements.define('tcd-virax-promotion', ViraxPromotion);
})();
